import EfSection from '@elem/ui/ef-section';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    const { locale = 'us' } = useRouter();
    const comA = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1721210220247/pc_clean.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1721210235762/m_clean.jpg',
    };
    const comB = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724920834908/pc_clean_eu.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724920961473/m_clean_eu.jpg',
    };
    let comObj = comA;
    if (['eu', 'de', 'uk'].includes(locale)) {
        comObj = comB;
    }
    return (
        <div className={styles.TheComp}>
            <EfSection position="hover" pc={comObj.pc} h5={comObj.h5} label={t('Q_label')} title={t('Q_title')} desc={t('Q_desc')} />
        </div>
    );
}
